import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { FormBuilder, FormGroup, FormControl, ValidatorFn, Validators } from '@angular/forms';

// #region Custom Classes

// #region Base Login Box Dialog Options Class

export class BaseLoginBoxDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    Validators?: ValidatorFn[];
    Username?: string;
}

// #endregion

// #region Base Login Box Dialog Result Class

export class BaseLoginBoxDialogResult {
    Username?: string;
    Password?: string;
}

// #endregion

// #endregion

@Component({
    selector: 'dialog-loginbox-component',
    styleUrls: ['loginbox.dialogcomponent.css'],
    templateUrl: 'loginbox.dialogcomponent.html',
})
export class LoginBoxDialogComponent implements OnInit {
    CancelTried: boolean;
    title: string;
    message: string;
    oktext: string;
    canceltext: string;
    validators: ValidatorFn[];
    username: string;

    loginForm: FormGroup;

    constructor(
        private dialogRef: MatDialogRef<LoginBoxDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: BaseLoginBoxDialogOptions,
        private fb: FormBuilder
    ) {
        this.CancelTried = false;
        this.title = data.TitleText || 'Credentials Required';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.validators = data.Validators || null;
        this.username = data.Username || null;
    }

    ngOnInit() {
        // Set up the form group
        this.loginForm = this.fb.group({
            username: [this.username],
            password: [null],
        });

        // If we were provided validators, set them now.
        if (this.validators && this.validators.length > 0) {
            const ctrl = this.loginForm.get('username');
            const toSet = [Validators.required, ...this.validators];

            ctrl.setValidators(this.validators);
            this.loginForm.updateValueAndValidity();
        }
    }

    CancelHandler() {
        if (this.CancelTried !== true) {
            // Set the flag, so the user has to hit it a second time.
            this.CancelTried = true;
            return;
        }

        // Oh well. Close it.
        this.dialogRef.close(null);
    }

    OKHandler() {
        const response = this.loginForm.value;

        this.dialogRef.close({
            Username: response.username,
            Password: response.password,
        } as BaseLoginBoxDialogResult);
    }
}
